import { render, staticRenderFns } from "./ShippingInstructionDialog.vue?vue&type=template&id=774c6e8f&"
import script from "./ShippingInstructionDialog.vue?vue&type=script&lang=ts&"
export * from "./ShippingInstructionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports